import { useLang } from "../context/LangContext";
import { WHATSAPP_URL, TELEGRAM_URL } from "../constants";
import { WhatsAppIcon, TelegramIcon } from "./icons";
import { Reveal } from "./Reveal";

export const FinalCta = () => {
  const { t } = useLang();
  const c = t.finalCta;

  return (
    <section className="relative py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div
            data-testid="final-cta-banner"
            className="relative overflow-hidden rounded-[32px] border border-white/10 bg-gradient-to-br from-navy-800 via-navy-900 to-navy-950 px-8 py-16 text-center sm:py-20"
          >
            <div className="animate-float-slow pointer-events-none absolute -left-32 top-0 h-[420px] w-[420px] rounded-full bg-blue-600/25 blur-[130px]" />
            <div className="animate-float-slow pointer-events-none absolute -right-32 bottom-0 h-[420px] w-[420px] rounded-full bg-violet-600/25 blur-[130px]" />
            <div className="bg-grid pointer-events-none absolute inset-0" />

            <div className="relative">
              <h2 className="mx-auto max-w-3xl font-display text-3xl font-black leading-tight text-white sm:text-5xl lg:text-6xl">
                {c.titleA}
                <br />
                <span className="text-gradient">{c.titleB}</span>
              </h2>
              <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-slate-400 sm:text-base">
                {c.subtitle}
              </p>

              <p className="mt-10 text-xs font-bold uppercase tracking-[0.35em] text-slate-400">{c.from}</p>
              <p data-testid="final-rate-display" className="text-gradient mt-2 font-display text-7xl font-black tracking-tight sm:text-8xl">
                0.9%
              </p>
              <p className="mt-5 font-display text-lg font-extrabold text-white sm:text-xl">{c.deadline}</p>
              <p className="mt-2 text-sm font-semibold text-blue-300">{c.lock}</p>

              <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="final-whatsapp-btn"
                  className="flex w-full items-center justify-center gap-2.5 rounded-full bg-gradient-to-r from-green-600 to-green-500 px-9 py-4 text-base font-bold text-white shadow-[0_0_36px_rgba(34,197,94,0.4)] transition-transform duration-300 hover:scale-[1.04] sm:w-auto"
                >
                  <WhatsAppIcon />
                  {c.whatsapp}
                </a>
                <a
                  href={TELEGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="final-telegram-btn"
                  className="flex w-full items-center justify-center gap-2.5 rounded-full bg-gradient-to-r from-sky-600 to-blue-500 px-9 py-4 text-base font-bold text-white shadow-[0_0_36px_rgba(56,160,240,0.4)] transition-transform duration-300 hover:scale-[1.04] sm:w-auto"
                >
                  <TelegramIcon />
                  {c.telegram}
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
